import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const faqApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Faq.api}?type=${data.role}&parentId=${data.id}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const addFaqApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Faq.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
export const updateFaqApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Faq.api + '/' + data.faqId}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
export const deleteFaqApi = async (data) => {
  const res = await requestInstance
    .delete(`${env}${API_ENDPOINT.Faq.api + '/' + data.faqId}`, data.data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const faqSectionApi = async (data) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Faq.sectionApi}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
